import React, { FC, memo, useState, useCallback } from 'react';

import Start from '../../pages/start';
import Question from '../../pages/question';
import Answer from '../../pages/answer';
import Result from '../../pages/result';
import Footer from '../footer';

import './layout.scss';

interface LayoutProps {}

const Layout: FC<LayoutProps> = memo(() => {
  const [step, setStep] = useState('start');
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentAnswer, setCurrentAnswer] = useState(0);
  const [isRightCurrentAnswer, setIsRightCurrentAnswer] = useState(false);

  const nextStep = useCallback(
    () => {
      if (currentQuestion < 9) {
        setStep('question');
      } else {
        setStep('result');
      }
    },
    [currentQuestion]
  );

  const viewAnswer = useCallback(
    (value: number, isRight: boolean) => {
      setCurrentAnswer(value);
      setIsRightCurrentAnswer(isRight);
      setStep('answer');
    },
    []
  );

  const viewQuestion = useCallback(
    () => {
      setCurrentQuestion(currentQuestion + 1);
      nextStep();
    },
    [currentQuestion, nextStep]
  );

  return (
    <div className={`page ${step === 'start' ? ' -bg' : ''}`}>
      { step === 'start' &&
        <Start onClick={nextStep} />
      }

      { step === 'question' &&
        <Question num={currentQuestion} onClick={viewAnswer} />
      }

      { step === 'answer' &&
        <Answer
          question={currentQuestion}
          current={currentAnswer}
          onClick={viewQuestion}
          isRight={isRightCurrentAnswer}
        />
      }

      { step === 'result' &&
        <Result />
      }

      <Footer />
    </div>
  );
});

export default Layout;
